<template>
    <div class="gofixInput gofixDropdownInput gofixDropdownTree" v-bind:class="{gofixInputHasDesc:desc,gofixInputError : (required && !value && blurInput),gofixInputDisable:disabled}">
        <div class="mainInput">
            <tree-select
                    :default-expand-level="defaultExpandLevel"
                    :options="options"
                    :load-options="loadOptions"
                    :search-nested="searchNested"
                    :value="value"
                    :normalizer="normalizer"
                    :valueFormat="valueFormat"
                    :searchable="searchable"
                    :openOnClick="openOnClick"
                    :openOnFocus="openOnFocus"
                    :noResultsText="noResultsText"
                    :noChildrenText="noChildrenText"
                    :clearable="clearable"
                    :multiple="multiple"
                    :disabled="disabled"
                    :alwaysOpen="alwaysOpen"
                    :flat="flat"
                    :maxHeight="maxHeight"
                    :limit="limit"
                    :limitText="limitText"
                    :sort-value-by="sortValueBy"
                    :disableRootCluster="disableRootCluster"
                    :disable-branch-nodes="disableBranchNodes"
                    placeholder=""
                    @input="handleInput"
                    @select="checkRoleProperty"
                    @close="blurInput = true"
                    @deselect="blurInput = true"
                    ref="selectTreeProperties"
            >
                <label slot="option-label" slot-scope="{ node }"
                       class="vue-treeselect__label">
                    <!--{{//v-bind:class="{'vue-tree-option-disabled' : !$checkRole(permissionAccess,permissionAction,node.raw.lft) || !checkSupplierProperty(node.raw)}"}}-->
                    {{ node.label }}
                </label>
            </tree-select>
            <div class="label">{{label}}<span class="iconRequired" v-if="showIconRequired && required">*</span></div>
        </div>
        <p class="desc" v-if="desc" v-html="desc"></p>
    </div>
</template>

<script>
    import { mapGetters} from 'vuex';
    import treeselect from '@riophae/vue-treeselect';
    import '@riophae/vue-treeselect/dist/vue-treeselect.min.css';
    export default {
        name: "dropdown-supplier",
        components: {
            'tree-select': treeselect
        },
        props: {
            contractId: {
                required: false,
                default: () => null
            },
            propertyId: {
                type: [Number,String],
                required: false,
                default: () => null
            },
            supplierContractId: {
                required: false,
                default: () => null
            },
            label: {
                type: String,
                required: false,
                default: () => "Select property"
            },
            value: {
                default: () => null
            },
            required: {
                type: Boolean,
                required: false,
                default: () => false
            },
            desc: {
                type: String,
                required: false,
                default: () => null
            },
            clearable: {
                type: Boolean,
                required: false,
                default: () => true
            },
            searchNested: {
                type: Boolean,
                required: false,
                default: () => false
            },
            searchable: {
                type: Boolean,
                required: false,
                default: () => true
            },
            openOnClick: {
                type: Boolean,
                required: false,
                default: () => true
            },
            openOnFocus: {
                type: Boolean,
                required: false,
                default: () => false
            },
            valueFormat: {
                type: String,
                required: false,
                default: () => "id"
            },
            noResultsText: {
                type: String,
                required: false,
                default: () => "No results found..."
            },
            noChildrenText: {
                type: String,
                required: false,
                default: () => "No sub-options."
            },
            permissionAction: {
                type: String,
                required: false,
                default: () => "read"
            },
            permissionAccess: {
                type: Object,
                required: false,
                default: () => null
            },
            disabled: {
                type: Boolean,
                default: false
            },
            showIconRequired: {
                type: Boolean,
                required: false,
                default: () => false
            },
            multiple: {
                type: Boolean,
                required: false,
                default: () => false
            },
            alwaysOpen: {
                type: Boolean,
                required: false,
                default: () => false
            },
            flat: {
                type: Boolean,
                required: false,
                default: () => false
            },
            defaultExpandLevel: {
                type: [Number,String],
                required: false,
                default: () => 1
            },
            maxHeight: {
                type: Number,
                required: false,
                default: () => 300
            },
            limit: {
                type: [Number,String],
                required: false,
                default: () => Infinity
            },
            limitText: {
                type: Function,
                required: false,
                default: () => "count => `and ${count} more`"
            },
            sortValueBy: {
                type: String,
                required: false,
                default: () => "ORDER_SELECTED"
            },
            disableRootCluster: {
                type: Boolean,
                required: false,
                default: () => false
            },
            propertyIdsDisable: {
                type: Array,
                required: false,
                default: () => []
            },
            disableBranchNodes: {
                type: Boolean,
                required: false,
                default: () => false
            },
        },

        data() {
            return {
                blurInput: false,
                options: [],
                vendorLinkingSupplier : []
            }
        },
        computed: {
            ...mapGetters({
                roles: 'AuthController/roles',
            }),
        },
        watch: {
            contractId: function (val) {
                this.loadRootProperty(true);
            },
            propertyId: function (val) {
                this.loadRootProperty(true);
            },

        },
        created(){
            this.loadRootProperty(true);
            if(this.supplierContractId){
                this.loadVendorLinkingSupplierContract();
            }
        },
        methods: {
            async handleInput (e) {
                this.$emit("input", e);
                this.$emit("change", e);
            },
            loadRootProperty(self = false){
                if(!this.contractId && !this.propertyId){
                    this.options = [];
                    return;
                }
                this.$store.dispatch("PropertyController/getTreeProperties",{
                    contract_id: this.contractId,
                    property_id: this.propertyId,
                    // is_active: true,
                    self:self,
                    disable_root_cluster: this.disableRootCluster,
                })
                    .then( reponses => {
                        this.options = reponses;
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },

            loadVendorLinkingSupplierContract(){
                this.$store.dispatch("VendorLinkingController/getList",{
                    limit:-1,
                    filter:{
                        supplier_contract_id: this.supplierContractId
                    }
                })
                    .then( reponses => {
                        this.vendorLinkingSupplier =reponses.data.data.items;
                    })
                    .catch(error => {
                        this.vendorLinkingSupplier = [];
                    });
            },

            async loadOptions({ action, parentNode, callback }) {
                await this.$store.dispatch("PropertyController/getTreeProperties",{
                    contract_id: null,
                    property_id: parentNode.data.id,
                    // is_active: true,
                    disable_root_cluster: this.disableRootCluster,
                })
                    .then( reponses => {
                        if(reponses.length){
                          parentNode.children = reponses;
                        }else{
                          parentNode.children = null;
                        }

                    })
                    .catch(error => {
                        console.log(error);
                    });
                callback();
            },
            // normalizer(node){
            //     return {
            //         id: node.id,
            //         label: node.name,
            //         children: ((node.rgt - node.lft) > 1) ? (Array.isArray(node.children) && node.children.length ? node.children : null) : undefined
            //     };
            // },
            normalizer(node){
                let nodeData = {
                    id: node.id,
                    label: node.name,
                    children: ((node.rgt - node.lft) > 1) ? (Array.isArray(node.children) && node.children.length ? node.children : null) : undefined
                };
                if(this.propertyIdsDisable && this.propertyIdsDisable.length && this.propertyIdsDisable.includes(node.id)) {
                    nodeData.isDisabled = true;
                }
                return nodeData
            },
            async checkRoleProperty(node,instanceId){
                if(!this.$checkRole(this.permissionAccess,this.permissionAction,node.lft) || !this.checkSupplierProperty(node)) {
                    this.$refs.selectTreeProperties.clear();
                    return this.$bvToast.toast("You don't have permission to this property", {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'warning',
                        solid: true
                    })
                }
            },
            checkSupplierProperty(node){
                if(this.supplierContractId){
                    let check = false;
                    for (let i = 0; i < this.vendorLinkingSupplier.length; i++){
                        let property = this.vendorLinkingSupplier[i].properties;
                        if(node.lft >= property.lft && node.rgt <= property.rgt){
                            check = true
                        }
                    }
                    return  check;
                }else{
                    return true;
                }
            }
        }
    }
</script>

<style scoped>

</style>
